var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6917 14.7781L14.3898 5.32502H14.6717C15.0919 5.32502 15.4498 5.00051 15.4498 4.54689C15.4498 4.12461 15.094 3.76877 14.6717 3.76877H13.1305L12.0689 1.89067C11.7621 1.43068 11.2115 1.125 10.6296 1.125L6.99498 1.125C6.41301 1.125 5.86235 1.43079 5.55562 1.89082L4.4941 3.76877L2.95293 3.76877C2.49932 3.76877 2.1748 4.12668 2.1748 4.54689C2.1748 4.99847 2.50135 5.32502 2.95293 5.32502H3.20553L3.90352 14.777L3.90361 14.7781C3.99487 15.8124 4.81782 16.575 5.85332 16.575H11.742C12.7775 16.575 13.6004 15.8124 13.6917 14.7781ZM10.7676 2.75698L11.2498 3.76877L6.37479 3.76877L6.84794 2.77147C6.89041 2.68125 6.94441 2.68125 6.99498 2.68125H10.6296C10.6861 2.68125 10.7342 2.68125 10.7676 2.75698ZM5.45922 14.6761L4.76224 5.32502L12.8331 5.32502L12.1361 14.6761C12.1108 14.8711 11.9389 15.0188 11.742 15.0188L5.85332 15.0188C5.65636 15.0188 5.48451 14.8711 5.45922 14.6761Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5675640ffa0ba8e6ca3bd0a742dc0085.svg";
export { ForwardRef as ReactComponent };